import { getProjectQueryFromContext } from "../../../context-options/utils"
import { ProjectsViewOptions } from "../../../projects/components/ProjectsViewSelect"
import { ProjectsQueryParams } from "../../../projects/api"
import { PROJECT_TYPE } from "../../../projects/constants"
import { AppMainContextType, AppSubContextType } from "../../../types/app-context"
import { Status } from "../../../types/common"

export const makeProjectListQuery = (
  context: AppMainContextType | AppSubContextType | null,
  view: ProjectsViewOptions
): ProjectsQueryParams => {
  const projectTypeQuery = { type: PROJECT_TYPE.NORMAL }
  if (view === "completed") {
    return {
      links: "true",
      files: "true",
      archived: "false",
      status: [Status.COMPLETED],
      ...projectTypeQuery,
      ...getProjectQueryFromContext(context),
    }
  }

  if (view === "archived") {
    return {
      links: "true",
      files: "true",
      archived: "true",
      ...projectTypeQuery,
      ...getProjectQueryFromContext(context),
    }
  }

  if (view === "rejected") {
    return {
      links: "true",
      files: "true",
      archived: "false",
      status: [Status.REJECTED],
      ...projectTypeQuery,
      ...getProjectQueryFromContext(context),
    }
  }

  if (view === "currentAndFuture") {
    return {
      links: "true",
      files: "true",
      archived: "false",
      status: [Status.NOT_STARTED, Status.IN_PROGRESS],
      ...projectTypeQuery,
      ...getProjectQueryFromContext(context),
    }
  }

  if (view === "templates") {
    return {
      type: PROJECT_TYPE.TEMPLATE,
      ...getProjectQueryFromContext(context),
    }
  }

  return { ...projectTypeQuery, ...getProjectQueryFromContext(context) }
}
